import { render, staticRenderFns } from "./DatatableDemo.vue?vue&type=template&id=5c8c531c&"
import script from "./DatatableDemo.vue?vue&type=script&lang=js&"
export * from "./DatatableDemo.vue?vue&type=script&lang=js&"
import style0 from "./DatatableDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports